import { careerDescriptionView } from './careerDescriptionView';
import { githubView } from './githubView';
import { selectPost } from './selectPost';
import { themeChange } from './themeChange';

export const events = {
	selectPost,
	careerDescriptionView,
	githubView,
	themeChange,
};
